(function () {
  "use strict";

  function initLenis() {
    if (!window.Lenis) return;
    var lenis = new Lenis({
      duration: 1.15,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
    });
    if (window.gsap && window.ScrollTrigger) {
      lenis.on("scroll", ScrollTrigger.update);
      gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      requestAnimationFrame(function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      });
    }
    window.FK_lenis = lenis;
  }

  function initScrollReveal() {
    if (!window.gsap || !window.ScrollTrigger) return;
    var animations = {
      "fade-up": { y: 56, opacity: 0 },
      "slide-left": { x: -70, opacity: 0 },
      "slide-right": { x: 70, opacity: 0 },
      "scale-up": { scale: 0.9, opacity: 0 },
      "clip-reveal": { clipPath: "inset(100% 0 0 0)", opacity: 0 },
    };
    document.querySelectorAll("[data-reveal]").forEach(function (section) {
      var type = section.dataset.reveal || "fade-up";
      var from = animations[type] || animations["fade-up"];
      var targets = section.querySelectorAll("[data-reveal-item]");
      var list = targets.length ? targets : [section];
      var vars = Object.assign({}, from, {
        duration: 1,
        ease: type === "clip-reveal" ? "power4.inOut" : "power3.out",
        stagger: 0.1,
        scrollTrigger: {
          trigger: section,
          start: "top 82%",
          toggleActions: "play none none reverse",
        },
      });
      gsap.from(list, vars);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initLenis();
    initScrollReveal();
  });
})();
